export default [
  {
    header: 'Генератор',
    resource: 'generator',
    action: 'view',
  },
  {
    title: 'Пакеты',
    route: 'generator-packs',
    icon: 'PackageIcon',
    tagVariant: 'light-warning',
    resource: 'generator',
    action: 'view',
  },
]
